import {SurveysPharmaciesState} from './pharmacies.interfaces';

export const pharmaciesInitialState: SurveysPharmaciesState = {
    ids: [],
    entities: null,
    idOfSelectedEntity: null,
    idsOfClosestPharmacies: [],
    pharmaciesLoadedOnce: false
};
